export const API_URL = process.env.REACT_APP_API_URL;
export const AUTH_URL = process.env.REACT_APP_AUTH_URL;
export const APP_TOKEN = process.env.REACT_APP_APP_TOKEN;